module.exports = __webpack_public_path__ + "static/img/2.c12cf022.svg";